import { useEffect, useState } from 'react';
import Loader from '../pages/home/components/Loader';
import { preloadAll } from '../utils/preloadAssets';

export default function Preloader({ onDone, timeoutMs = 60000 }) {
  const [loaded, setLoaded] = useState(0);
  const [total, setTotal] = useState(1);
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const res = await preloadAll({
          timeoutMs,
          onProgress: ({ loaded: L, total: T }) => {
            if (!mounted) return;
            setLoaded(L);
            setTotal(T);
          }
        });

        if (!mounted) return;
        if (res.timedOut) {
          console.warn('Preloader: timed out while loading assets', res.errors.slice(0, 5));
          setStatus('timeout');
          // per "full-blocking" requirement: still wait the timeout, then continue
          // user requested entire site be loaded first — proceed after timeout
        } else if (res.errors.length) {
          console.warn('Preloader: some assets failed to load', res.errors.slice(0, 8));
          setStatus('done');
        } else {
          setStatus('done');
        }

        // small delay so users see final state
        setTimeout(() => {
          if (!mounted) return;
          onDone();
        }, 150);
      } catch (err) {
        console.error('Preloader error', err);
        if (!mounted) return;
        setStatus('error');
        // fail-open after a short pause to avoid trapping users indefinitely
        setTimeout(() => onDone(), 500);
      }
    })();

    return () => {
      mounted = false;
    };
  }, [onDone, timeoutMs]);

  const pct = Math.min(100, Math.round((loaded / Math.max(1, total)) * 100));

  return (
    <div>
      <Loader />
    </div>
  );
}
